import React,{Component} from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment/build/index";
import moment from "moment/moment";
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import SimpleReactValidator from 'simple-react-validator';
import {history} from '../../../shared/configure-store';
import {toast, ToastContainer} from 'react-toastify';
import {Link, withRouter} from 'react-router-dom';
import Image from '../../../images/done.png';
import Api from '../../../libraries/api';
import {bindActionCreators} from "redux";
import {RootActions} from "../../../shared/root-action";
import {connect} from "react-redux";
import language from "../../../libraries/label-lang";
import AuthHelper from "../../../libraries/auth-helper";
import templateId from "../../../libraries/lang-id";
import _ from 'lodash';

SimpleReactValidator.addLocale('indo', templateId);


class OrdersAdd extends Component {

    constructor(props) {

        super(props);


        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );

        this.validator1 = new SimpleReactValidator(
            {
                locale: lang
            }
        );


        this.state = {
            loading: false,
            loadingButton: false,
            showButton: false,

            errors: [],

            warehouseList: [],
            reservationList: [],
            storageList: [],
            productsList: [],
            products: [],

            step1: true,
            step2: false,
            step3: false,
            final: false,

            orderid:'',
            use: false,

            warehouseId: '',
            platform: '',
            otherPlatform:'',
            platformInvoiceId: '',
            customerName: '',
            customerPhoneNumber: '',
            customerAddress: '',
            customerSubdistrict: '',
            customerDistrict: '',
            customerCity: '',
            customerState: '',
            customerPostalCode: '',
            recipientAddress: '',
            recipientSubdistrict: '',
            recipientDistrict: '',
            recipientCity: '',
            recipientState: '',
            recipientPostalCode: '',
            recipientName: '',
            recipientPhoneNumber: '',
            logisticCompany: '',
            courierName: '',
            courierPhone: '',
            estimatedPickupTime: null,
            estimatedTime: null,
            estimatedDate: null,
            labelScreenshot: '',
            image_name: '',
            product: '',

            productsList_tmp:[]
        }
    }

    componentDidMount(){

        document.title = 'Fresh Factory - Add Order';

        Api.get('/warehouses').then(resp => {
            if (resp.data) {

                this.setState({
                    warehouseList: resp.data,
                    loading: false,
                })

            }
        }).catch(err => {
            this.showMessage(false, err.message);
        });
    };

    UNSAFE_componentWillReceiveProps() {

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );
    }

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };


    __fetchLockerSize = (w,h,l,s) => {

        this.setState({

            loading3: true

        });

        let data = {
            width: w,
            height: h,
            length: l,
            storage: s,
        };
        Api.post('/lockersize/find',data).then(resp => {

            if (resp.data.length === 0) {
                this.setState({
                    lockerSizeName: 0,
                    loading3: false
                });

                return false
            }
            if (resp.data) {
                this.setState({
                    lockerSizeName: resp.data.name,
                    lockerSizeId: resp.data.id,
                    loading3: false
                });
            }

        }).catch(err => {
            console.log(err);
        });
    };

    __fetchProduct = () => {
        Api.get('/products/'+this.state.warehouseId+'/stock').then(resp => {
            if (resp.data) {

                this.setState({
                    productsList: resp.data,
                    // productsList_tmp: resp.data,
                    loading: false,
                })

            }
            this.handleReplaceList();
        }).catch(err => {
            this.showMessage(false, err.message);
        });
    };


    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        },()=>{
            // if(prop == 'warehouseId'){
            //     this.__fetchProduct();
            // }
        });

    };

    handleGo  = (link) => {
        history.push(link);
    };

    handleNext  = (e) => {
        e.preventDefault();

        console.log(this.validator.getErrorMessages())
        if (!this.validator.allValid()) {

            this.setState({
                    errors: this.validator.getErrorMessages()
                }
            );

            return false;

        }

        this.setState({
            errors: {},
            step2: true,
            step1: false,
        },()=>{
            this.__fetchProduct();
        });

    };

    handleNext1  = (e) => {
        this.setState({
            step3: true,
            step2: false,
            step1: false,
        });

    };

    handleBack  = () => {
        this.setState({
            step2: false
        });
    };

    handleUpload = e => {

        let temp = _.get(e,'target.files[0]',false);

        this.setState({
            errors: {labelScreenshot:''},
        });

        if(temp){
            if(e.target.files[0].size > 999999){

                this.setState({
                    errors: {
                        labelScreenshot: 'This file is too big. Maximum size is 1MB.'
                    },
                });

            }else if(e.target.files[0].name.toLowerCase().search('.jpeg') === -1 &&
                e.target.files[0].name.toLowerCase().search('.jpg') === -1  &&
                e.target.files[0].name.toLowerCase().search('.png') === -1){

                this.setState({
                    errors: {
                        labelScreenshot: 'This file is invalid. Only accept .jpg, .jpeg and .png'
                    },
                });

            }else{

                this.setState({
                    labelScreenshot: URL.createObjectURL(e.target.files[0]),
                    image_file: e.target.files[0],
                    image_name: e.target.files[0].name,
                });

            }
        }
    };

    handleChecked = name => e => {

        this.setState({

            [name]: e.target.checked,

        }, () => {
            if(this.state.use) {
                this.setState({
                    recipientName: this.state.customerName,
                    recipientPhoneNumber: this.state.customerPhoneNumber,
                    recipientAddress: this.state.customerAddress,
                    recipientSubdistrict: this.state.customerSubdistrict,
                    recipientDistrict: this.state.customerDistrict,
                    recipientCity: this.state.customerCity,
                    recipientState: this.state.customerState,
                    recipientPostalCode: this.state.customerPostalCode,
                })
            }else {
                this.setState({
                    recipientName: '',
                    recipientPhoneNumber: '',
                    recipientAddress: '',
                    recipientSubdistrict: '',
                    recipientDistrict: '',
                    recipientCity: '',
                    recipientState: '',
                    recipientPostalCode: '',
                })
            }
        });

    };

    handleAdd = (e) => {
        let data = e.target.value;
        let exp = this.state.products;
        let temp = {
            id : data.productId,
            name : data.productName,
            sku : data.skuNumber,
            quantity : 1,
            ikusStored: data.stock
        };

        exp.push(temp);
        this.setState({
            products: exp,
            showButton: true,
            });

        this.handleReplaceList();
    };

    handlePlus = (id) => {
        let data = this.state.products;
        let message = '';
        let pop = false;
        _.forEach(data, function(v,k){
            if(v.id === id){
                if((v.quantity+1) <= v.ikusStored) {
                    v.quantity = v.quantity + 1;
                }
                else{
                    pop = true;
                    v.quantity = v.ikusStored;
                    v.quantity = v.ikusStored ? v.ikusStored : v.quantity && v.quantity-1 > 1 ? v.quantity : 1;
                    // message = v.ikusStored ? 'Maximal order '+v.ikusStored : 'Data maximal tidak ditemukan';
                    message = 'Stok produk yang ada di warehouse sudah mencapai limit';
                }
            }
        });

        if(pop) {
            this.showMessage(false, message);
        }

        this.setState({
            products: data,
        });
    };

    handleMinus = (id) => {
        let data = this.state.products;

        let to_delete_list = 0;

        _.forEach(data, function(v,k){
            if(v.id === id){
                v.quantity = v.quantity-1;

                if(v.quantity == 0){
                    to_delete_list = k+1;
                }
            }
        });

        if(to_delete_list){
            data.splice(to_delete_list-1,1);
        }

        this.setState({
            products: data,
        });

        this.handleReplaceList();
    };

    handleReplaceList = () =>{
        let x = Object.keys(this.state.products);
        let n = [];
        this.state.productsList.map(f=>{
            n.push(f);
        });
        if(x && x.length) {
            x.map(key => {
                if (key) {
                    let idCheck = this.state.products[key].id;
                    if(n && n.length) {
                        let nC = 0;
                        n.map((d, xd) => {
                            if (d.productId == idCheck) {
                                nC = xd + 1;
                            }
                        });
                        if (nC) {
                            n.splice(nC - 1, 1);
                        }
                    }
                }
            });

            this.setState({
                productsList_tmp: n
            });
        }
        else{
            this.setState({
                productsList_tmp: n
            });
        }
    };

    handleSubmit = (e) => {

        e.preventDefault();

        if (!this.validator1.allValid()) {

            this.setState({
                    errors: this.validator1.getErrorMessages()
                }
            );

            return false;

        }

        this.setState({
                errors: {},
                loadingButton: true
            }
        );

        let platform = this.state.platform === 'Lainnya' ? this.state.otherPlatform : this.state.platform
        // console.log(platform)
        let formData = new FormData();
        let estimatedPickupTime = moment(this.state.estimatedDate).format('YYYY-MM-DD')+' '+moment(this.state.estimatedTime).format('HH:mm:ss');
        formData.append('warehouseId', this.state.warehouseId);
        formData.append('platform', platform);
        formData.append('platformInvoiceId', this.state.platformInvoiceId);
        formData.append('customerName', this.state.customerName);
        formData.append('customerPhoneNumber', this.state.customerPhoneNumber);
        formData.append('customerAddress', this.state.customerAddress);
        formData.append('customerSubdistrict', this.state.customerSubdistrict);
        formData.append('customerDistrict', this.state.customerDistrict);
        formData.append('customerCity', this.state.customerCity);
        formData.append('customerState', this.state.customerState);
        formData.append('customerPostalCode', this.state.customerPostalCode);
        formData.append('recipientName', this.state.recipientName);
        formData.append('recipientPhoneNumber', this.state.recipientPhoneNumber);
        formData.append('recipientAddress', this.state.recipientAddress);
        formData.append('recipientSubdistrict', this.state.recipientSubdistrict);
        formData.append('recipientDistrict', this.state.recipientDistrict);
        formData.append('recipientCity', this.state.recipientCity);
        formData.append('recipientState', this.state.recipientState);
        formData.append('recipientPostalCode', this.state.recipientPostalCode);
        formData.append('logisticCompany', this.state.logisticCompany);
        formData.append('courierName', this.state.courierName);
        formData.append('courierPhone', this.state.courierPhone);
        formData.append('estimatedPickupTime', estimatedPickupTime);


        if(this.state.products.length > 0) {
            _.forEach(this.state.products, function(v,i){
                Object.keys(v).forEach(key => {
                    formData.append(`products[${i}][${key}]`, v[key]);
                });
            });
        }
        // console.log(formData)
     /*   if(this.state.image_file) {
            formData.append('labelScreenshot', this.state.image_file);
        }
*/
        Api.putFile('/orders',{
            method: 'POST',
            body: formData
        }).then(resp => {

            this.setState({
                loadingButton: false,
                final: true,
                step3: false,

            });

            this.showMessage(true, 'Order successfully added');

        }).catch(err => {

            let error = '';
            if(Array.isArray(err.message)) {
                error = err.message[0]
            }else {
                error = err.message
            }

            this.setState({
                    errors: err.errors ? err.errors : 'error',
                    loadingButton: false
                }
            );

            if(err.status_code === 500) {
                this.showMessage(false, err.message);
                return false;
            }

            this.showMessage(false, error);

        });


    };

    handleDate (date, prop){

        this.setState({

            [prop]: date

        })

    };

    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (

            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item'><Link to='/orders' >{text.label_orders}</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>{text.button_add}</li>
                    </ol>
                </nav>

                <div className='row'>
                    {this.state.step1 &&
                    <div className='col-lg-8 col-xl-7'>
                        <div className='card-white'>
                            <h2 className='text-uppercase'>{text.button_add} {text.label_orders}</h2>
                            <p className='text-blue'>Info penerima ( Step 1 dari 2 )</p>
                            <form name='add' id='addProduct' className='row' noValidate>
                                <div className='col-12 mb-2'>
                                    <h2>INFO PEMESAN</h2>
                                    <div className='form-group'>
                                        <TextField
                                            select
                                            id='warehouse'
                                            name='warehouse'
                                            label={text.label_warehouse}
                                            onChange={(e) => this.handleChange(e, 'warehouseId')}
                                            value={this.state.warehouseId}
                                            fullWidth
                                        >
                                            {this.state.warehouseList.map((option, idx) => (
                                                <MenuItem key={idx} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.validator.message('warehouseId', this.state.warehouseId, 'required')}
                                        <div className='text-danger'>{this.state.errors.warehouseId}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='customerName'
                                            name='customerName'
                                            label={text.label_name}
                                            onChange={(e) => this.handleChange(e, 'customerName')}
                                            value={this.state.customerName}
                                            fullWidth
                                        />
                                        {this.validator.message('customerName', this.state.customerName, 'required')}
                                        <div className='text-danger'>{this.state.errors.customerName}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='number'
                                            id='customerPhoneNumber'
                                            name='customerPhoneNumber'
                                            label={text.label_phone}
                                            onChange={(e) => this.handleChange(e, 'customerPhoneNumber')}
                                            value={this.state.customerPhoneNumber}
                                            helperText="08xxxxxxx"
                                            fullWidth
                                        />
                                        {this.validator.message('customerPhoneNumber', this.state.customerPhoneNumber, 'required')}
                                        <div className='text-danger'>{this.state.errors.customerPhoneNumber}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='customerAddress'
                                            name='customerAddress'
                                            label={text.label_address}
                                            onChange={(e) => this.handleChange(e, 'customerAddress')}
                                            value={this.state.customerAddress}
                                            fullWidth
                                            multiline
                                            rows={4}
                                        />
                                        {this.validator.message('customerAddress', this.state.customerAddress, 'required')}
                                        <div className='text-danger'>{this.state.errors.customerAddress}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='customerSubdistrict'
                                            name='customerSubdistrict'
                                            label={text.label_subdistrict}
                                            onChange={(e) => this.handleChange(e, 'customerSubdistrict')}
                                            value={this.state.customerSubdistrict}
                                            fullWidth
                                        />
                                        <div className='text-danger'>{this.state.errors.customerSubdistrict}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='customerDistrict'
                                            name='customerDistrict'
                                            label={text.label_district}
                                            onChange={(e) => this.handleChange(e, 'customerDistrict')}
                                            value={this.state.customerDistrict}
                                            fullWidth
                                        />
                                        <div className='text-danger'>{this.state.errors.customerDistrict}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='customerCity'
                                            name='customerCity'
                                            label={text.label_city}
                                            onChange={(e) => this.handleChange(e, 'customerCity')}
                                            value={this.state.customerCity}
                                            fullWidth
                                        />
                                        {this.validator.message('customerCity', this.state.customerCity, 'required')}
                                        <div className='text-danger'>{this.state.errors.customerCity}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='customerState'
                                            name='customerState'
                                            label={text.label_state}
                                            onChange={(e) => this.handleChange(e, 'customerState')}
                                            value={this.state.customerState}
                                            fullWidth
                                        />
                                        {this.validator.message('customerState', this.state.customerState, 'required')}
                                        <div className='text-danger'>{this.state.errors.customerState}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='customerPostalCode'
                                            name='customerPostalCode'
                                            label={text.label_zipcode}
                                            onChange={(e) => this.handleChange(e, 'customerPostalCode')}
                                            value={this.state.customerPostalCode}
                                            fullWidth
                                        />
                                        {this.validator.message('customerPostalCode', this.state.customerPostalCode, 'required')}
                                        <div className='text-danger'>{this.state.errors.customerPostalCode}</div>
                                    </div>
                                </div>

                                <div className='col-12 mt-4 mb-2'>
                                    <h2>INFO PENERIMA</h2>
                                    <div className='form-group'>
                                        <FormControl component='fieldset' className='col '>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            color='primary'
                                                            checked={this.state.use}
                                                            onChange={this.handleChecked('use')}
                                                            value='use' />}
                                                    className='label-tnc'
                                                    label='Nama dan nomor pengiriman sama dengan pemesan'
                                                />
                                                <div className='text-left text-alert'>{this.state.errors.use}</div>
                                            </FormGroup>
                                        </FormControl>
                                    </div>

                                    <div className={!this.state.use ? 'form-group' : 'form-group d-none'}>
                                        <TextField
                                            type='text'
                                            id='recipientName'
                                            name='recipientName'
                                            label='Nama Penerima'
                                            onChange={(e) => this.handleChange(e, 'recipientName')}
                                            value={this.state.recipientName}
                                            fullWidth
                                        />
                                        {this.validator.message('recipientName', this.state.recipientName, 'required')}
                                        <div className='text-danger'>{this.state.errors.recipientName}</div>
                                    </div>
                                    <div className={!this.state.use ? 'form-group' : 'form-group d-none'}>
                                        <TextField
                                            type='number'
                                            id='recipientPhoneNumber'
                                            name='recipientPhoneNumber'
                                            label='No. HP Penerima'
                                            onChange={(e) => this.handleChange(e, 'recipientPhoneNumber')}
                                            value={this.state.recipientPhoneNumber}
                                            helperText="08xxxxxxx"
                                            fullWidth
                                        />
                                        {this.validator.message('recipientPhoneNumber', this.state.recipientPhoneNumber, 'required')}
                                        <div className='text-danger'>{this.state.errors.recipientPhoneNumber}</div>
                                    </div>
                                    <div className={!this.state.use ? 'form-group' : 'form-group d-none'}>
                                        <TextField
                                            type='text'
                                            id='recipientAddress'
                                            name='recipientAddress'
                                            label={text.label_address}
                                            onChange={(e) => this.handleChange(e, 'recipientAddress')}
                                            value={this.state.recipientAddress}
                                            fullWidth
                                            multiline
                                            rows={4}
                                        />
                                        {this.validator.message('recipientAddress', this.state.recipientAddress, 'required')}
                                        <div className='text-danger'>{this.state.errors.recipientAddress}</div>
                                    </div>
                                    <div className={!this.state.use ? 'form-group' : 'form-group d-none'}>
                                        <TextField
                                            type='text'
                                            id='recipientSubdistrict'
                                            name='recipientSubdistrict'
                                            label={text.label_subdistrict}
                                            onChange={(e) => this.handleChange(e, 'recipientSubdistrict')}
                                            value={this.state.recipientSubdistrict}
                                            fullWidth
                                        />
                                        <div className='text-danger'>{this.state.errors.recipientSubdistrict}</div>
                                    </div>
                                    <div className={!this.state.use ? 'form-group' : 'form-group d-none'}>
                                        <TextField
                                            type='text'
                                            id='recipientDistrict'
                                            name='recipientDistrict'
                                            label={text.label_district}
                                            onChange={(e) => this.handleChange(e, 'recipientDistrict')}
                                            value={this.state.recipientDistrict}
                                            fullWidth
                                        />
                                        <div className='text-danger'>{this.state.errors.recipientDistrict}</div>
                                    </div>
                                    <div className={!this.state.use ? 'form-group' : 'form-group d-none'}>
                                        <TextField
                                            type='text'
                                            id='recipientCity'
                                            name='recipientCity'
                                            label={text.label_city}
                                            onChange={(e) => this.handleChange(e, 'recipientCity')}
                                            value={this.state.recipientCity}
                                            fullWidth
                                        />
                                        {this.validator.message('recipientCity', this.state.recipientCity, 'required')}
                                        <div className='text-danger'>{this.state.errors.recipientCity}</div>
                                    </div>
                                    <div className={!this.state.use ? 'form-group' : 'form-group d-none'}>
                                        <TextField
                                            type='text'
                                            id='recipientState'
                                            name='recipientState'
                                            label={text.label_state}
                                            onChange={(e) => this.handleChange(e, 'recipientState')}
                                            value={this.state.recipientState}
                                            fullWidth
                                        />
                                        {this.validator.message('recipientState', this.state.recipientState, 'required')}
                                        <div className='text-danger'>{this.state.errors.recipientState}</div>
                                    </div>
                                    <div className={!this.state.use ? 'form-group' : 'form-group d-none'}>
                                        <TextField
                                            type='text'
                                            id='recipientPostalCode'
                                            name='recipientPostalCode'
                                            label={text.label_zipcode}
                                            onChange={(e) => this.handleChange(e, 'recipientPostalCode')}
                                            value={this.state.recipientPostalCode}
                                            fullWidth
                                        />
                                        {this.validator.message('recipientPostalCode', this.state.recipientPostalCode, 'required')}
                                        <div className='text-danger'>{this.state.errors.recipientPostalCode}</div>
                                    </div>
                                </div>
                                <div className='col-12 text-center mt-4'>
                                    <Button
                                        variant='contained'
                                        className='mr-3'
                                        onClick={() => this.handleGo('/orders')}
                                    >
                                        {text.button_back}
                                    </Button>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        className=''
                                        onClick={this.handleNext}
                                        disabled={this.state.loadingButton}
                                    >
                                        {text.button_next} {this.state.loadingButton &&
                                    <i className='fa fa-spinner fa-spin'> </i>}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>

                    }
                    {this.state.step2 &&
                        <div className='col-lg-9 col-xl-10'>
                            <div className='card-white mb-3'>
                                <h2 className='text-uppercase'>{text.button_add} {text.label_orders}</h2>
                                <p className='text-blue'>Info penerima ( Step 2 dari 2 )</p>
                                <form name='add' id='addProduct' className='row' noValidate>
                                    <div className='col-md-6 col-lg-5 mb-2'>
                                        {this.state.productsList_tmp.length > 0 ?
                                            <div className='form-group'>
                                                <TextField
                                                    select
                                                    id='product'
                                                    name='product'
                                                    label='Cari SKU / Nama Produk'
                                                    onChange={(e) => this.handleAdd(e, 'product')}
                                                    value={this.state.product}
                                                    fullWidth
                                                >
                                                    {this.state.productsList_tmp.map((option, idx) => (
                                                        <MenuItem key={idx} value={option}>
                                                            {option.productName}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                                <div className='text-danger'>{this.state.errors.product}</div>
                                            </div> :
                                            <div className='form-group'>
                                                <label>Cari SKU / Nama Produk</label>
                                                <p>{text.label_stock_unavailable}</p>
                                            </div>
                                        }

                                    </div>
                                </form>
                            </div>

                            <div className='card-white'>
                                <h2 className='text-uppercase'>Produk {text.label_orders} Anda</h2>

                                <div className='row border-top pt-2 mb-3'>
                                    <div className='col-md-3'><p className='mb-0' >{text.label_sku}</p></div>
                                    <div className='col-md-6'><p className='mb-0'>{text.label_product}</p></div>
                                    <div className='col-md-3'><p className='mb-0'>Jumlah Fulfillment</p></div>
                                </div>
                                { this.state.products.map((item,idx) => (
                                    <div className='row border-bottom py-2' key={idx}>
                                        <div className='col-md-3'><p className='mb-0' >{item.sku}</p></div>
                                        <div className='col-md-6'><p className='mb-0'>{item.name}</p></div>
                                        <div className='col-md-3'>
                                            <input type='number'
                                                   className='form-control tab'
                                                   value={item.quantity}
                                                   onChange={(e) => this.handleChange(e, 'quantity', idx)}/>
                                            <button className='btn-table'
                                                    onClick={() => this.handleMinus(item.id)}>-</button>
                                            <button className='btn-table'
                                                    onClick={() => this.handlePlus(item.id)}>+</button>

                                        </div>
                                    </div>
                                ))}

                            </div>
                            {
                                this.state.showButton &&
                                <div className='col-12 text-right mt-4 p-0'>

                                    <Button
                                        variant='contained'
                                        color='primary'
                                        className=''
                                        onClick={this.handleNext1}
                                        disabled={this.state.loadingButton}
                                    >
                                        {text.button_next} { this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                                    </Button>
                                </div>
                            }

                        </div>
                    }

                    {this.state.step3 &&
                    <div className='col-lg-8 col-xl-9'>
                        <div className='card-white'>
                            <div className='heading'>
                                <p>Pemesan</p>
                            </div>
                            <h2 className='mb-0'>{this.state.customerName}</h2>
                            <p><strong>({this.state.customerPhoneNumber})</strong></p>
                            <p>{this.state.customerAddress + ', ' + this.state.customerSubdistrict + ', ' + this.state.customerDistrict+ ', '+ this.state.customerCity+ ', '+ this.state.customerState+ ', '+this.state.customerPostalCode}</p>
                            <div className='heading'>
                                <p>Penerima</p>
                            </div>
                            <h2 className='mb-0'>{this.state.recipientName}</h2>
                            <p><strong>({this.state.recipientPhoneNumber})</strong></p>
                            <p>{this.state.recipientAddress  + ', ' + this.state.recipientSubdistrict + ', ' + this.state.recipientDistrict+ ', '+ this.state.recipientCity+ ', '+ this.state.recipientState+ ', '+this.state.recipientPostalCode}</p>
                            <div className='heading'>
                                <p>Platform Pemesanan</p>
                            </div>
                            <form name='platform' id='platform' className='row' noValidate>
                                <div className='col-md-6 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            select
                                            id='platform'
                                            name='platform'
                                            label='Platform Fulfillment'
                                            onChange={(e) => this.handleChange(e, 'platform')}
                                            value={this.state.platform}
                                            fullWidth
                                        >
                                            <MenuItem value='Tokopedia'>Tokopedia</MenuItem>
                                            <MenuItem value='Blibli'>Blibli</MenuItem>
                                            <MenuItem value='Shopee'>Shopee</MenuItem>
                                            <MenuItem value='Website'>Website</MenuItem>
                                            <MenuItem value='Instagram'>Instagram</MenuItem>
                                            <MenuItem value='Lainnya'>Lainnya</MenuItem>
                                        </TextField>
                                        {this.validator1.message('platform', this.state.platform, 'required')}
                                        <div className='text-danger'>{this.state.errors.platform}</div>
                                    </div>
                                </div>
                                {this.state.platform === 'Lainnya' ?
                                    <div className='col-md-6 mb-2'>
                                        <div className='form-group'>
                                            <TextField
                                                type='text'
                                                id='otherPlatform'
                                                name='otherPlatform'
                                                label='Platform Lainnya'
                                                onChange={(e) => this.handleChange(e, 'otherPlatform')}
                                                value={this.state.otherPlatform}
                                                fullWidth
                                            />
                                        </div>
                                    </div> : <div></div>
                                }
                                <div className='col-md-6 mb-2'>
                                <div className='form-group'>
                                    <TextField
                                        type='text'
                                        id='platformInvoiceId'
                                        name='platformInvoiceId'
                                        label='Nomer Invoice di Platform'
                                        onChange={(e) => this.handleChange(e, 'platformInvoiceId')}
                                        value={this.state.platformInvoiceId}
                                        fullWidth
                                    />
                                    {this.validator1.message('platformInvoiceId', this.state.platformInvoiceId, 'required')}
                                    <div className='text-danger'>{this.state.errors.platformInvoiceId}</div>
                                </div>
                                </div>
                                <div className='col-md-6 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            select
                                            id='logisticCompany'
                                            name='logisticCompany'
                                            label='Pilih Kurir'
                                            onChange={(e) => this.handleChange(e, 'logisticCompany')}
                                            value={this.state.logisticCompany}
                                            fullWidth
                                        >
                                            <MenuItem value='Gojek Instant'>Gojek Instant</MenuItem>
                                            <MenuItem value='Gojek Same Day'>Gojek Same Day</MenuItem>
                                            <MenuItem value='Grab Instant'>Grab Instant</MenuItem>
                                            <MenuItem value='Grab Same Day'>Grab Same Day</MenuItem>
                                            <MenuItem value='Tenant'>Tenant</MenuItem>
                                        </TextField>
                                        {this.validator1.message('logisticCompany', this.state.logisticCompany, 'required')}
                                        <div className='text-danger'>{this.state.errors.logisticCompany}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <label className='mb-0'>Estimasi Tanggal Penjemputan</label>
                                    <div className='row'>
                                        <div className='col-6'>
                                            <div className="form-group">
                                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                                    <DatePicker
                                                        label="Tanggal"
                                                        value={this.state.estimatedDate}
                                                        onChange={(date) => this.handleDate(date, 'estimatedDate')}
                                                        format={'DD MMM YYYY'}
                                                        cancelLabel="BATAL"
                                                        fullWidth
                                                    />
                                                </MuiPickersUtilsProvider>
                                                {this.validator1.message('estimatedDate', this.state.estimatedDate, 'required')}
                                                <div className='text-danger'>{this.state.errors.estimatedDate}</div>
                                            </div>
                                        </div>
                                        <div className='col-6'>
                                            <div className="form-group">
                                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                                    <TimePicker
                                                        label="Waktu"
                                                        value={this.state.estimatedTime}
                                                        onChange={(date) => this.handleDate(date, 'estimatedTime')}
                                                        format={'hh:mm a'}
                                                        cancelLabel="BATAL"
                                                        fullWidth
                                                    />
                                                </MuiPickersUtilsProvider>
                                                {this.validator1.message('estimatedTime', this.state.estimatedTime, 'required')}
                                                <div className='text-danger'>{this.state.errors.estimatedTime}</div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                {/* <div className='form-group'>
                                    <TextField
                                        type='text'
                                        id='platformInvoiceId'
                                        name='platformInvoiceId'
                                        label='Nomor Resi'
                                        onChange={(e) => this.handleChange(e, 'platformInvoiceId')}
                                        value={this.state.platformInvoiceId}
                                        fullWidth
                                    />
                                    {this.validator.message('platformInvoiceId', this.state.platformInvoiceId, 'required')}
                                    <div className='text-danger'>{this.state.errors.platformInvoiceId}</div>
                                </div>*/}
                                {/*<div className='col-12 col-lg-9 mb-2'>
                                    <div className='form-group position-relative'>
                                        <TextField
                                            type='text'
                                            id='imageFiles'
                                            name='imageFiles'
                                            label='Upload Label Paket (pilihan)'
                                            value={this.state.image_name}
                                            fullWidth
                                        />
                                        <label
                                            htmlFor="labelScreenshot"
                                            id="upload-image"
                                        >{text.label_browse}</label>
                                        <TextField
                                            accept='.jpg,.jpeg,.png'
                                            type='file'
                                            id='labelScreenshot'
                                            name='labelScreenshot'
                                            className='avatar d-none'
                                            onChange={this.handleUpload}
                                            fullWidth
                                        />
                                        {this.validator1.message('labelScreenshot', this.state.labelScreenshot, 'required')}
                                        <div className='text-danger'>{this.state.errors.labelScreenshot}</div>
                                    </div>
                                </div>*/}
                                <div className='col-md-6 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='courierName'
                                            name='courierName'
                                            label='Nama Driver / Resi'
                                            onChange={(e) => this.handleChange(e, 'courierName')}
                                            value={this.state.courierName}
                                            fullWidth
                                        />
                                        {this.validator1.message('courierName', this.state.courierName, 'required')}
                                        <div className='text-danger'>{this.state.errors.courierName}</div>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='number'
                                            id='courierPhone'
                                            name='courierPhone'
                                            label='No HP Kurir'
                                            onChange={(e) => this.handleChange(e, 'courierPhone')}
                                            value={this.state.courierPhone}
                                            fullWidth
                                        />
                                        <div className='text-danger'>{this.state.errors.courierPhone}</div>
                                    </div>
                                </div>
                            </form>

                            <div className='card-nota'>
                                <h2 className='text-uppercase'>Produk {text.label_orders} Anda</h2>

                                <div className='row border-bottom pt-2 mb-3'>
                                    <div className='col-md-3'><p className='mb-0' >{text.label_sku}</p></div>
                                    <div className='col-md-6'><p className='mb-0'>{text.label_product}</p></div>
                                    <div className='col-md-3'><p className='mb-0'>Jumlah {text.label_orders}</p></div>
                                </div>
                                { this.state.products.map((item,idx) => (
                                    <div className='row py-2' key={idx}>
                                        <div className='col-md-3'><p className='mb-0' >{item.sku}</p></div>
                                        <div className='col-md-6'><p className='mb-0'>{item.name}</p></div>
                                        <div className='col-md-3'>
                                            <p className='mb-0'>{item.quantity}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className='text-right mt-4'>

                                <Button
                                    variant='contained'
                                    color='primary'
                                    className=''
                                    onClick={this.handleSubmit}
                                    disabled={this.state.loadingButton}
                                >
                                    {text.button_next} {this.state.loadingButton &&
                                <i className='fa fa-spinner fa-spin'> </i>}
                                </Button>

                            </div>

                        </div>
                    </div>

                    }

                    {this.state.final &&
                    <div className='col-lg-8 col-xl-9'>
                        <div className='card-white text-center'>
                            <h2 className='text-uppercase mb-3'>Fulfillment Anda Telah Selesai.</h2>

                            <img src={Image} alt='finish' width='325px' className='img-fluid mb-3' />
                            <p>Fulfillment Anda Sedang Kami Proses.<br />
                                Terima kasih.</p>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={() => this.handleGo('/orders')}
                            >
                                {text.button_back}
                            </Button>
                        </div>
                    </div>
                    }


                </div>

                <ToastContainer />
            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OrdersAdd));